<p-megamenu
    [model]="model()"
    [style]="style()"
    class="fcp-megamenu"
    [orientation]="orientation()"
    [id]="id()"
    [ariaLabel]="ariaLabel()"
    [ariaLabelledBy]="ariaLabelledBy()"
    [breakpoint]="breakpoint()"
    [scrollHeight]="scrollHeight()"
    [disabled]="disabled()"
    [tabindex]="tabindex()"
>
    @if (startTemplate) {
        <ng-template pTemplate="start">
            <ng-container *ngTemplateOutlet="startTemplate"></ng-container>
        </ng-template>
    }
    <ng-template pTemplate="item" let-item>
        <a
            class="p-megamenu-item-link"
            [class.p-disabled]="item.disabled"
            [routerLink]="item.routerLink"
            (click)="onItemLinkClick($event, item)"
            [queryParams]="item.queryParams"
            [fragment]="item.fragment"
            [queryParamsHandling]="item.queryParamsHandling"
            [preserveFragment]="item.preserveFragment"
            [skipLocationChange]="item.skipLocationChange"
            [replaceUrl]="item.replaceUrl"
            [state]="item.state"
            [attr.href]="item.routerLink ? null : item.url"
            [attr.target]="item.routerLink ? null : item.target"
            [attr.rel]="item.routerLink ? null : externalLinkRel(item.target)"
            [attr.tabindex]="-1"
            pRipple
        >
            <span class="p-megamenu-item-label">{{ item.label }}</span>
            @if (hasSubmenu(item)) {
                <span class="p-megamenu-submenu-icon fc-font-icon fc-font-icon-chevron-down" aria-hidden="true"></span>
            }
        </a>
    </ng-template>
    @if (endTemplate) {
        <ng-template pTemplate="end">
            <ng-container *ngTemplateOutlet="endTemplate"></ng-container>
        </ng-template>
    }
</p-megamenu>
